export const AdV5 = {
  fields: {
    frequencyCapList: {
      merge: false,
    },
  },
};
